<!--Legal check VDE701/702 for in-vitro-->
@if (model.showVDE701702) {
    <div class="row mb-3">
        <label
            class="col-lg-3 col-form-label text-start"
            translate="CONFIRMATION_EQUIPMENT_CHECK_VDE701702_LABEL"
        ></label>
        <div class="col-lg-9">
            <pace-core-radio-input
                [(model)]="model.legalCheckVDE701702"
                [parentForm]="parentForm"
                id="radioLegalCheckVDE70170Options"
                (valueChange)="onLegalCheckOptionChange()"
            >
            </pace-core-radio-input>
        </div>
    </div>
    @if (showLegalCheckVDE701702Options) {
        <div class="row mb-3">
            <div class="col-lg-4 col-md-6 offset-lg-3">
                <pace-core-text-input
                    [(model)]="model.legalCheckVDEPCResistance"
                    (valueChange)="resetRequiredOption()"
                    [parentForm]="parentForm"
                    [ariaLabel]="model.configLegalCheckVDEPCResistanceText"
                >
                </pace-core-text-input>
            </div>
            <label class="col-lg-5 col-md-6">{{ model.configLegalCheckVDEPCResistanceText }}</label>
        </div>
        <div class="row mb-3">
            <div class="col-lg-4 col-md-6 offset-lg-3">
                <pace-core-text-input
                    [(model)]="model.legalCheckVDEDeviceLeakage"
                    (valueChange)="resetRequiredOption()"
                    [parentForm]="parentForm"
                    [ariaLabel]="model.configLegalCheckVDEDeviceLeakageText"
                >
                </pace-core-text-input>
            </div>
            <label class="col-lg-5 col-md-6">{{ model.configLegalCheckVDEDeviceLeakageText }}</label>
        </div>
        <div class="row mb-3">
            <div class="col-lg-4 col-md-6 offset-lg-3">
                <pace-core-text-input
                    [(model)]="model.legalCheckVDEInsulationResistance"
                    (valueChange)="resetRequiredOption()"
                    [parentForm]="parentForm"
                    [ariaLabel]="model.configLegalCheckVDEInsulationResistanceText"
                >
                </pace-core-text-input>
            </div>
            <label class="col-lg-5 col-md-6">{{ model.configLegalCheckVDEInsulationResistanceText }}</label>
        </div>
    }
    <hr class="separator" />
}
@if (model.showIEC62353) {
    <div class="row mb-3">
        <label class="col-lg-3 col-form-label text-start">{{ model.legalCheckIEC62353Text }}</label>
        <div class="col-lg-9">
            <pace-core-radio-input
                [(model)]="model.legalCheckIEC62353"
                [parentForm]="parentForm"
                id="radioLegalCheckIEC62353Options"
                (valueChange)="onLegalCheckOptionChange()"
            >
            </pace-core-radio-input>
        </div>
    </div>
    @if (showLegalCheckIEC62353Options) {
        <div class="row mb-3">
            <label class="col-lg-4 mb-2 mb-lg-0">{{ model.configLegalCheckPCResistanceText }}</label>
            <div class="col-lg-4">
                <pace-core-text-input
                    id="legalCheckPCResistance"
                    [(model)]="model.legalCheckPCResistance"
                    (valueChange)="resetRequiredOption()"
                    [parentForm]="parentForm"
                    [ariaLabel]="model.configLegalCheckPCResistanceText"
                >
                </pace-core-text-input>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-lg-4 mb-2 mb-lg-0">{{ model.configLegalCheckDeviceLeakageText }}</label>
            <div class="col-lg-4">
                <pace-core-text-input
                    id="legalCheckDeviceLeakage"
                    [(model)]="model.legalCheckDeviceLeakage"
                    (valueChange)="resetRequiredOption()"
                    [parentForm]="parentForm"
                    [ariaLabel]="model.configLegalCheckDeviceLeakageText"
                >
                </pace-core-text-input>
            </div>
        </div>
    }
    <hr class="separator" />
}
<!-- only visible for Germany and certain business units -->
@if (model.showXRayCheck) {
    <div class="row mb-3">
        <label class="col-lg-3 col-form-label text-start" translate="CONFIRMATION_EQUIPMENT_XRAY_CHECK_LABEL"></label>
        <div class="col-lg-9">
            <pace-core-checkbox-input
                [(model)]="model.legalCheckXRay"
                [parentForm]="parentForm"
            ></pace-core-checkbox-input>
        </div>
    </div>
    <hr class="separator" />
}
<!-- only visible for Spain and certain business units -->
@if (model.showDosageCheck) {
    <div class="row mb-3">
        <label class="col-lg-3 col-form-label text-start">{{ model.legalCheckDosageText }}</label>
        <div class="col-lg-9">
            <pace-core-radio-input [(model)]="model.legalCheckDosage" [parentForm]="parentForm"></pace-core-radio-input>
        </div>
    </div>
}
<!-- only visible for Switzerland and certain business units -->
@if (model.showRadioProtection) {
    <div class="row mb-3">
        <label
            class="col-lg-3 col-form-label text-start"
            translate="CONFIRMATION_EQUIPMENT_RADIO_PROTECTION_LABEL"
        ></label>
        <div class="col-lg-9">
            <pace-core-checkbox-input
                [(model)]="model.legalCheckRadioProtection"
                (valueChange)="onLegalCheckOptionChange()"
                [parentForm]="parentForm"
            ></pace-core-checkbox-input>
        </div>
    </div>
    @if (model.legalCheckRadioProtection.value) {
        <div class="row mb-3">
            <div class="col-lg-4 col-md-6 offset-lg-3">
                <pace-core-checkbox-input
                    [(model)]="model.legalCheckRadioProtectionAcceptanceTest"
                    (valueChange)="resetRequiredOption()"
                    [parentForm]="parentForm"
                ></pace-core-checkbox-input>
            </div>
        </div>
    }
    @if (model.legalCheckRadioProtection.value) {
        <div class="row mb-3">
            <div class="col-lg-4 col-md-6 offset-lg-3">
                <pace-core-checkbox-input
                    [(model)]="model.legalCheckRadioProtectionPartialAcceptanceTest"
                    (valueChange)="resetRequiredOption()"
                    [parentForm]="parentForm"
                ></pace-core-checkbox-input>
            </div>
        </div>
    }
    @if (model.legalCheckRadioProtection.value) {
        <div class="row mb-3">
            <div class="col-lg-4 col-md-6 offset-lg-3">
                <pace-core-checkbox-input
                    [(model)]="model.legalCheckRadioProtectionHealthCheck"
                    (valueChange)="resetRequiredOption()"
                    [parentForm]="parentForm"
                ></pace-core-checkbox-input>
            </div>
        </div>
    }
    @if (model.legalCheckRadioProtection.value) {
        <div class="row mb-3">
            <div class="col-lg-4 col-md-6 offset-lg-3">
                <pace-core-checkbox-input
                    [(model)]="model.legalCheckRadioProtectionConsistencyTest"
                    (valueChange)="resetRequiredOption()"
                    [parentForm]="parentForm"
                ></pace-core-checkbox-input>
            </div>
        </div>
    }
    <hr class="separator" />
}
<!-- only visible for Netherlands -->
@if (model.showNEN1010) {
    @if (model.showNEN1010) {
        <div class="row mb-3">
            <label class="col-lg-3 col-form-label text-start" translate="CONFIRMATION_EQUIPMENT_NEN1010_LABEL"></label>
            <div class="col-lg-9">
                <pace-core-radio-input
                    [(model)]="model.legalCheckNEN1010"
                    (valueChange)="onLegalCheckOptionChange()"
                    [parentForm]="parentForm"
                ></pace-core-radio-input>
            </div>
        </div>
    }
    @if (showLegalCheckNEN1010Options) {
        <div class="row mb-3">
            <div class="col-lg-9 offset-lg-3">
                <pace-core-radio-input
                    [useResponsiveLayout]="true"
                    [(model)]="model.legalCheckNEN1010Radio"
                    (valueChange)="onLegalCheckOptionChange()"
                    [parentForm]="parentForm"
                ></pace-core-radio-input>
            </div>
        </div>
    }
    @if (
        showLegalCheckNEN1010Options &&
        model.legalCheckNEN1010Radio.selectedEntry.value === model.configLegalCheckMeasurementPerformedCode
    ) {
        <div class="row mb-3">
            <div class="col-lg-4 col-md-6 offset-lg-3">
                <pace-core-text-input
                    [(model)]="model.legalCheckNEN1010Resistance"
                    [parentForm]="parentForm"
                    [ariaLabel]="model.configLegalCheckInsulationResistanceText"
                ></pace-core-text-input>
            </div>
            <label class="col-lg-5 col-md-6">{{ model.configLegalCheckInsulationResistanceText }}</label>
        </div>
    }
    <hr class="separator" />
}
<!-- only visible for Australia/New Zealand -->
@if (model.showLegalCheck3551) {
    <div class="row mb-3 align-items-center">
        <label class="col-md-8 col-form-label text-start fw-normal">{{
            model.legalCheck3551DetachablePowerCordText
        }}</label>
        <div class="col-md-4">
            <pace-core-radio-input
                [(model)]="model.legalCheck3551DetachablePowerCord"
                (valueChange)="setOther3551legalChecksToNo(model.legalCheck3551DetachablePowerCord)"
                [parentForm]="parentForm"
            ></pace-core-radio-input>
        </div>
    </div>
    <div class="row mb-3 align-items-center">
        <label class="col-md-8 col-form-label text-start fw-normal">{{
            model.legalCheck3551PermanentlyConnectedText
        }}</label>
        <div class="col-md-4">
            <pace-core-radio-input
                [(model)]="model.legalCheck3551PermanentlyConnected"
                (valueChange)="setOther3551legalChecksToNo(model.legalCheck3551PermanentlyConnected)"
                [parentForm]="parentForm"
            ></pace-core-radio-input>
        </div>
    </div>
    <div class="row mb-3 align-items-center">
        <label class="col-md-8 col-form-label text-start fw-normal">{{
            model.legalCheck3551NonDetachablePowerCordText
        }}</label>
        <div class="col-md-4">
            <pace-core-radio-input
                [(model)]="model.legalCheck3551NonDetachablePowerCord"
                (valueChange)="setOther3551legalChecksToNo(model.legalCheck3551NonDetachablePowerCord)"
                [parentForm]="parentForm"
            ></pace-core-radio-input>
        </div>
    </div>
    <hr class="separator" />
}
<!-- only visible for France -->
@if (model.showLegalCheckVerification) {
    <div class="row mb-3 align-items-center">
        <label class="col-md-8 col-form-label text-start fw-normal">{{
            model.legalCheckVerifiedSecurityDeviceText
        }}</label>
        <div class="col-md-4">
            <pace-core-radio-input
                [(model)]="model.legalCheckVerifiedSecurityDevice"
                [parentForm]="parentForm"
            ></pace-core-radio-input>
        </div>
    </div>
    <div class="row mb-3 align-items-center">
        <label class="col-md-8 col-form-label text-start fw-normal">{{
            model.legalCheckResumptionAfterUserValidationText
        }}</label>
        <div class="col-md-4">
            <pace-core-radio-input
                [(model)]="model.legalCheckResumptionAfterUserValidation"
                [parentForm]="parentForm"
            ></pace-core-radio-input>
        </div>
    </div>
    <hr class="separator" />
}
<div class="row mb-3">
    <div class="offset-md-2">
        @if (model.options.isNoToolAllowed) {
            <pace-core-checkbox-input
                [(model)]="model.noMeasurementTool"
                (valueChange)="onNoMeasurementToolsUsedChange()"
                [parentForm]="parentForm"
            ></pace-core-checkbox-input>
        }
    </div>
</div>
@if (!model.noMeasurementTool.value && model.options.isNoToolAllowed) {
    <hr class="separator" />
}
@if (model.showRadioActiveSurvey && model.radioActiveSurvey && !model.noMeasurementTool.value) {
    <div class="row mb-3">
        <label class="col-lg-3 text-start" translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_USED_TITLE"></label>
        <div class="col-lg-9">
            <pace-core-radio-input [(model)]="model.radioActiveSurvey" [parentForm]="parentForm" id="radioActiveSurvey">
            </pace-core-radio-input>
        </div>
    </div>
    @if (model.isRadioActiveSelectedNo) {
        <label class="col-3 col-form-label" translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_NOT_USED"></label>
    }
    @if (model.isRadioActiveSelectedYes) {
        <div class="row mb-3">
            <label
                class="col-lg-3 col-form-label text-start"
                translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_BACKGROUND_LABEL"
            ></label>
            <div class="col-lg-3 col-md-4">
                <pace-core-number-input
                    id="radioActiveBackground"
                    [(model)]="model.radioActiveBackground"
                    [parentForm]="parentForm"
                    (valueChange)="model.recalculateRadioActiveSurvey(calibrationValue)"
                    [ariaLabel]="'CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_BACKGROUND_LABEL' | translate"
                >
                </pace-core-number-input>
            </div>
        </div>
        <div class="row mb-3 d-md-flex d-none">
            <label class="col-4" translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_LOCATION_LABEL"></label>
            <label class="col-2" translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_METER_CPM_LABEL"></label>
            <label class="col-3" translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_NET_LABEL"></label>
            <label class="col-3" translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_DPM_LABEL"></label>
        </div>
        @for (tool of model.radioActiveModelList; track tool; let i = $index) {
            <div class="row mb-3">
                <label
                    class="d-md-none d-flex"
                    translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_LOCATION_LABEL"
                ></label>
                <div class="col-md-4 mb-md-0 mb-3">
                    <pace-core-text-input
                        [(model)]="tool.location"
                        [parentForm]="parentForm"
                        [ariaLabel]="'CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_LOCATION_LABEL' | translate"
                    >
                    </pace-core-text-input>
                </div>
                <label
                    class="d-md-none d-flex"
                    translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_METER_CPM_LABEL"
                ></label>
                <div class="col-md-2 mb-md-0 mb-3">
                    <pace-core-number-input
                        [(model)]="tool.meterOrCpm"
                        [parentForm]="parentForm"
                        (valueChange)="tool.calculateNetAndDpm(model.radioActiveBackground.value, calibrationValue)"
                        [ariaLabel]="'CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_METER_CPM_LABEL' | translate"
                    >
                    </pace-core-number-input>
                </div>
                <label
                    class="d-md-none d-flex"
                    translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_NET_LABEL"
                ></label>
                <div class="col-md-3 mb-md-0 mb-3">
                    <pace-core-number-input
                        [(model)]="tool.net"
                        [parentForm]="parentForm"
                        [ariaLabel]="'CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_NET_LABEL' | translate"
                    >
                    </pace-core-number-input>
                </div>
                <label
                    class="d-md-none d-flex"
                    translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_DPM_LABEL"
                ></label>
                <div class="col-md-2 mb-md-0 mb-3">
                    <pace-core-number-input
                        [(model)]="tool.dpm"
                        [parentForm]="parentForm"
                        [ariaLabel]="'CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_DPM_LABEL' | translate"
                    >
                    </pace-core-number-input>
                </div>
                <div class="col-md-1 mb-md-0 mb-3">
                    @if (tool.isDeletable && model.radioActiveModelList.length > 1) {
                        <button
                            id="radioSurveyDeletebtn"
                            class="btn btn-warning float-md-start float-end"
                            (click)="deleteRadioActiveTool(i)"
                            [attr.aria-label]="'CONFIRMATION_MEASUREMENT_TOOLS_DELETE_ARIA_LABEL' | translate"
                        >
                            <fa-icon [icon]="faTrashAlt"></fa-icon>
                        </button>
                    }
                </div>
                <hr class="separator d-md-none d-flex" />
            </div>
        }
        <div class="row mb-3">
            @if (!model.noMeasurementTool.value) {
                <div class="col-12">
                    <button
                        class="btn btn-primary float-end"
                        translate="CONFIRMATION_MEASUREMENT_TOOLS_ADD_MEASUREMENT_RADIOACTIVE_LOCATION"
                        (click)="addNewRadioActiveTool()"
                    ></button>
                </div>
            }
        </div>
    }
}
@if (model.radioActiveSurvey) {
    <hr class="separator" />
}
@if (!model.showMeasurementToolsDetails && !model.noMeasurementTool.value) {
    @for (tool of model.measurementTools.value; track tool; let i = $index; let isFirst = $first) {
        <div class="row mb-3">
            @if (isFirst) {
                <label
                    for="measurementToolId"
                    class="col-2 col-md-1 col-form-label"
                    translate="CONFIRMATION_MEASUREMENT_TOOLS_ID"
                ></label>
            }
            <div class="col-md-4 col-8">
                <pace-core-text-input
                    id="measurementToolId"
                    [(model)]="tool.measurementToolId"
                    [parentForm]="parentForm"
                    (valueChange)="validateForm()"
                    [ariaLabel]="'CONFIRMATION_MEASUREMENT_TOOLS_ID' | translate"
                ></pace-core-text-input>
            </div>
            <div class="col-md-1 col-2">
                @if (model.options.isDeletable && model.measurementTools.value.length > 1) {
                    <button
                        type="button"
                        id="btnDelete"
                        class="btn btn-warning"
                        (click)="deleteTool(i)"
                        [attr.aria-label]="'CONFIRMATION_MEASUREMENT_TOOLS_DELETE_ARIA_LABEL' | translate"
                    >
                        <fa-icon [icon]="faTrashAlt"></fa-icon>
                    </button>
                }
            </div>
            @if (showCalibrationDate) {
                <div class="d-flex flex-column align-items-md-start align-items-center col-md-6 my-md-0 my-3">
                    <button
                        class="btn btn-primary"
                        [disabled]="tool.measurementToolId.value === ''"
                        (click)="getCalibrationDate(tool.measurementToolId.value, i)"
                        translate="CONFIRMATION_MEASUREMENT_TOOLS_CHECK_CALIBRATION_DATE"
                    ></button>
                </div>
            }
            <hr class="separator d-md-none d-flex" />
        </div>
    }
}
@if (model.showMeasurementToolsDetails && !model.noMeasurementTool.value) {
    <div class="row mb-3 d-md-flex d-none">
        <label class="col-3" translate="CONFIRMATION_MEASUREMENT_TOOLS_DESCRIPTION"></label>
        <label class="col-3" translate="CONFIRMATION_MEASUREMENT_TOOLS_TID"></label>
        <label class="col-3" translate="CONFIRMATION_MEASUREMENT_TOOLS_CALIBRATED_UNTIL"></label>
        <label class="col-3" translate="CONFIRMATION_MEASUREMENT_TOOLS_GID"></label>
    </div>
    @for (tool of measurementToolModels$ | async; track trackByMeasurementToolId(i, tool); let i = $index) {
        <div class="row mb-3">
            <label class="d-md-none d-flex" translate="CONFIRMATION_MEASUREMENT_TOOLS_DESCRIPTION"></label>
            <div class="col-md-3 mb-md-0 mb-3">
                @if (tool.dropdownVisibility$ | async) {
                    <pace-core-dropdown
                        [parentForm]="parentForm"
                        [(model)]="tool.dropdownValues"
                        (valueChange)="onDropdownChange(tool, $event)"
                    >
                    </pace-core-dropdown>
                }
                @if ((tool.dropdownVisibility$ | async) === false) {
                    <pace-core-text-input
                        [(model)]="tool.textDescription"
                        [parentForm]="parentForm"
                        (valueChange)="tool.onDescriptionTextChange()"
                        [ariaLabel]="'CONFIRMATION_MEASUREMENT_TOOLS_DESCRIPTION' | translate"
                    >
                    </pace-core-text-input>
                }
            </div>
            <label class="d-md-none d-flex" translate="CONFIRMATION_MEASUREMENT_TOOLS_TID"></label>
            <div class="col-md-3 mb-md-0 mb-3">
                <pace-core-text-input
                    (blurEvent)="checkForDuplicateTechId(tool, i, $event)"
                    (valueChange)="onTechnicalIdChange(tool, i, $event)"
                    [(model)]="tool.technicalId"
                    [parentForm]="parentForm"
                    [ariaLabel]="'CONFIRMATION_MEASUREMENT_TOOLS_TID' | translate"
                >
                </pace-core-text-input>
            </div>
            <label class="d-md-none d-flex" translate="CONFIRMATION_MEASUREMENT_TOOLS_CALIBRATED_UNTIL"></label>
            <div class="col-md-3 mb-md-0 mb-3">
                <pace-core-date-input
                    [(model)]="tool.calibrationUntil"
                    [parentForm]="parentForm"
                    [ariaLabel]="'CONFIRMATION_MEASUREMENT_TOOLS_CALIBRATED_UNTIL' | translate"
                >
                </pace-core-date-input>
            </div>
            <label class="d-md-none d-flex" translate="CONFIRMATION_MEASUREMENT_TOOLS_GID"></label>
            <div class="col-md-2 mb-md-0 mb-3">
                <pace-core-text-input
                    [(model)]="tool.gid"
                    [parentForm]="parentForm"
                    [ariaLabel]="'CONFIRMATION_MEASUREMENT_TOOLS_GID' | translate"
                >
                </pace-core-text-input>
            </div>
            <div class="col-md-1 mb-md-0 mb-3">
                @if (model.options.isDeletable && model.measurementTools.value.length > 1) {
                    <button
                        type="button"
                        id="btnDeletes"
                        class="btn btn-warning float-md-start float-end"
                        (click)="deleteTool(i)"
                        [attr.aria-label]="'CONFIRMATION_MEASUREMENT_TOOLS_DELETE_ARIA_LABEL' | translate"
                    >
                        <fa-icon [icon]="faTrashAlt"></fa-icon>
                    </button>
                }
            </div>
            <hr class="separator d-md-none d-flex" />
        </div>
    }
}
<div class="row mb-3">
    @if (!model.noMeasurementTool.value) {
        <div class="col-12">
            <button
                type="button"
                class="btn btn-primary float-end"
                translate="CONFIRMATION_MEASUREMENT_TOOLS_ADD_MEASUREMENT_TOOLS"
                (click)="addNewTool()"
            ></button>
        </div>
    }
</div>
